import { createRef, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CLIENT_REPORTS_LIST, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Formik, useFormikContext } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, errorMessageToast, getAge, getPdfBlob, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import { CLIENT_REPORT_TYPES, CONSULTATION_REPORT_V2_QUESTIONS, dobFormat, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS, REPORT_IDS, reportDateFormat } from "config/constants";
import LoadingButton from "components/shared/LoadingButton";
import moment from "moment";
import ReportError from "components/shared/ReportsV2/ReportError";
import GuardianDetailList from "components/shared/ReportsV2/GuardianDetailsList";
import { useGetDisciplineAreasQuery, useUploadFileMutation } from "store/services/utility";
import { useCopyReportsMutation, useGetReportClientsAssessmentFeedbackQuery, useSubmitConsulatitonReportMutation, useSubmitIndividualSessionReportMutation, useSubmitSchoolDischargeScreeningReportMutation } from "store/services/clients/reports-v2/schoolReports";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { DischargeScreeningPdfDocV2 } from "components/PDF/Clients/ReportsV2/DischargeScreeningPdfV2";
import { useSelector } from "react-redux";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import arro_right_img from "../../../../../../Assets/images/arrow-right.png";
import preview_img from "../../../../../../Assets/images/preview-btn.png";
import ClientDetails from "components/shared/ReportsV2/ClientDetails";
import { ArrowLeftIcon } from "Assets/icons";
import RenderQuestion from "components/shared/ReportsV2/Questions/Index";
import GoalsTracking from "components/shared/ReportsV2/GoalsTracking/Index";
import { reportQuestionsValidationSchema, reportQuestionsValidationSchemaV2 } from "utils/validation/validationHelpers";
import { date, object } from "yup";
import { formatReportFeedback, formatReportFeedbackV2, reportInitialValues, reportInitialValuesV2 } from "helpers/assessment";
import CKEditorField from "components/CkEditor/CkEditor";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import IndividualSessionReportPdfDocV2 from "components/PDF/Clients/ReportsV2/IndividualSessionReportPdfV2";
import down_arrow_img from "../../../../../../Assets/images/down-arro.png"
import QuestionMultipleObservation from "components/shared/ReportsV2/Questions/QuestionMultipleObservation";
import ConsultationReportPdfDocV2 from "components/PDF/Clients/ReportsV2/ConsultationReportPdfDocV2";
import QuestionMultipleRecommendation from "components/shared/ReportsV2/Questions/QuestionMultipleRecommendation";
import { toPng } from "html-to-image";
import getValidationSchema from "./validation";
import { isEmpty } from "lodash";
import PDFDocViewer from "components/PDF/PDFDocViewer";
import ReportSubmitButton from "components/shared/ReportsV2/ReportSubmitButton";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import AutosaveReport from "components/shared/ReportsV2/AutosaveReport";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import confirmDialogV2 from "utils/confirmationDialogV2";

const SchoolConsultationReport = () => {
  const navigate = useNavigate();
  const sliderRefs = useRef([]);
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [publishPdfModal, setPublishPdfModal] = useState(false)
  const [goalSubmissionError, setGoalSubmissionError] = useState(null);
  const [chartImages, setChartImages] = useState(null);
  const { assessmentId, clientId, reportId } = useParams();
  const clientType = "school"
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null)

  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.INDIVIDUAL_SESSION_REPORT_V2]?.title);

  const [copyReport, { isLoading: copyReportLoading }] = useCopyReportsMutation()
  const [submitReport, { isLoading: submitReportLoading }] = useSubmitConsulatitonReportMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetReportClientsAssessmentFeedbackQuery({ reportId: REPORT_IDS.CONSULATION_REPORT_V2, clientId, submittedReportId: reportId });
  const [document, setDocument] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)

  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;

  const reportGoals = data?.assesmentData?.reportGoals;
  const reportRecommendations = data?.assesmentData?.reportRecommendations;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseApprentice = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");

  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

  const chartRefs = useRef([]);
  const formRefs = useMemo(() => {
    if (!reportGoals?.length) return [];
    return reportGoals?.map((goal) => {
      return createRef();
    });
  }, [reportGoals]);

  const therapist = useSelector((state) => state?.auth?.user)

  const initialValues = useMemo(() => {
    if (!data) return {};
    const guardianList = data?.assesment?.AssesmentGuardianAssigned?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
    let answers = data?.assesmentData?.reportAnswers;
    const [year, month, day] = data?.client_detail?.dob ? data?.client_detail?.dob.split("-") : "";
    const formattedDob = `${day}${month}${year}`;
    const password = `${data?.firstname}${data?.lastname}${formattedDob}`
    let values = {
      screening_date: data?.assesment?.screening_date || new Date(),
      apprentice_id: data?.assesment?.studentSignatureId,
      student: data?.assesment?.studentSignatureId ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.studentSignatureId } : null,
      signatureBy: data?.assesment?.signatureBy || null,
      guardianList,
      recommendation: data?.assesmentData?.reportRecommendations?.length ? data?.assesmentData?.reportRecommendations?.map((item) => ({ id: item?.id || null, answers: item?.answers, attachmentData: item?.attachmentData ? JSON.parse(item?.attachmentData) : [] })) : [],
      observations: data?.assesmentData?.reportObservations?.length ? data?.assesmentData?.reportObservations?.map((item) => ({ id: item?.id || "", notes: item?.notes || "", area_id: { label: item?.AssesmentObservationGoalArea?.name, value: item?.area_id }, tracker_percentage: item?.tracker_percentage || 0, show_tracker: item?.show_tracker || "show", obs_date: item?.obs_date || null, strategy: item?.AssessmentObservationStrategy?.length ? item?.AssessmentObservationStrategy?.map((strategy) => ({ id: strategy?.id, template_id: strategy?.template_id, title: strategy?.TemplateDetail?.title || "", answers: strategy?.answers == "null" ? "" : strategy?.answers || "", attachmentData: strategy?.attachmentData ? JSON.parse(strategy?.attachmentData) : [], id: strategy?.id || "" })) : [{ answers: "", attachmentData: [] }] })) : [{ notes: "", tracker_percentage: 0, show_tracker: "show", strategy: [{ answers: "", attachmentData: [] }] }],
      // emailFormData: {
      //   pdfPassword: password
      // }
    };

    values = reportInitialValuesV2(values, reportQuestions, answers);

    return values;
  }, [data]);


  const validationSchema = useMemo(() => {
    return getValidationSchema(currentTab, reportQuestions)
  }, [reportQuestions, currentTab]);

  const handleSubmitStep = async (values) => {
    setSubmitting(true);

    try {
      let payload = formatReportFeedbackV2(reportHeading, reportQuestions, { ...values });

      let body = {
        goals: [],
        assesment_location: "in-person",
        feedbacks: payload.feedbacks,
        screening_date: values?.screening_date,
        report_heading: reportHeading,
        guardianList: values?.guardianList,
        recommendation: values?.recommendation,
        signatureBy: values?.signatureBy,
        observations: values?.observations?.map((x) => ({ ...x, area_id: x?.area_id?.value, }))
      };

      // save chart images for later use
      if (currentTab == 3) {
        const sliderImages = await getSliderImages();
        console.log('sliderImages', sliderImages)
        if (sliderImages) {
          setChartImages(sliderImages);
        }
      }

      (formRefs?.length && reportGoals?.length) && reportGoals?.forEach((goal, index) => {
        if (!formRefs[index]?.current) return;
        let values = formRefs[index].current.values;
        if (values?.hasUnsavedChanges) {
          setGoalSubmissionError("There are unsaved changes, please save them before proceeding");
          throw new Error("Form contains unsaved changes");
        }

        body.goals.push({
          goal_id: goal.id,
          goal_notes: values?.goal_notes,
          goal_attachementData: values?.goal_attachementData
        })
      });

      setGoalSubmissionError(null);

      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          ...body,
          studentSignatureId: values?.apprentice_id,
          save_for_later: "yes",
        }
      }
      else {

        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
          [...data.client_detail.client_guardian_mapping]
            .map((guardian) => {
              const id = guardian?.client_guardian?.id;
              const role = guardian?.client_guardian?.client_role?.title;

              const matchedGuardian = values?.guardianList?.find(
                (item) => item.id === id
              );

              if (matchedGuardian) {
                return {
                  ...guardian,
                  key: matchedGuardian?.role  // or matchedGuardian.role
                };
              }

              return null;
            })
            .filter(Boolean);

        const pdfData = {
          ...body,
          clientId: data?.id,
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob, reportDateFormat),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.grade,
          schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
          schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians,
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format("MMMM D, YYYY"),
          reportQuestions: data?.assesmentData?.reportQuestions,
          reportAnswers: data?.assesmentData?.reportAnswers,
          assessmentGoals: reportGoals,
          images: chartImages,
          observations: values?.observations,
          recommendation: values?.recommendation,
          formikValues: values
        }

        const doc = (
          <ConsultationReportPdfDocV2
            data={pdfData}
          />
        )

        // setDocument(doc)

        const filename = `Clinical Plan - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          ...body,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: CLIENT_REPORT_TYPES[assessmentId]?.name || "Individual session report",
          }],
          emailFormData: values?.emailFormData,
          current_step: "submit_and_email",
        }
      }

      const response = await submitReport({ data: body, clientId: assessmentAssignedId }).unwrap()
      refetch()
      setSubmitting(false);
      if (!values?.isAutoSave) {
        successMessageToast(response.message)
      }
      if (!values?.saveForLater) {
        // navigate(SCHOOL_CLIENT_LIST)
        navigate(SCHOOL_CLIENT_DETAIL.replace(":id", clientId))
      }
    } catch (error) {
      setSubmitting(false);
      console.log('error', error)
    }
  };

  const handleViewPdf = async (values) => {
    const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
      [...data.client_detail.client_guardian_mapping]
        .map((guardian) => {
          const id = guardian?.client_guardian?.id;
          const role = guardian?.client_guardian?.client_role?.title;

          const matchedGuardian = values?.guardianList?.find(
            (item) => item.id === id
          );

          if (matchedGuardian) {
            return {
              ...guardian,
              key: matchedGuardian?.role  // or matchedGuardian.role
            };
          }

          return null;
        })
        .filter(Boolean);

    const pdfData = {
      clientId: data?.id,
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob, reportDateFormat),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.grade,
      schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
      schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians,
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: values?.screening_date ? dateFormat(values?.screening_date, reportDateFormat) : null,
      reportQuestions: data?.assesmentData?.reportQuestions,
      reportAnswers: data?.assesmentData?.reportAnswers,
      assessmentGoals: reportGoals,
      images: chartImages,
      observations: values?.observations,
      recommendation: values?.recommendation,
      formikValues: values
    }

    const doc = (
      <ConsultationReportPdfDocV2
        data={pdfData}
      />
    )

    setDocument(doc)
    setPdfModal(true)

  };

  const getSliderImages = async () => {
    if (!sliderRefs.current?.length) return null;

    return await Promise.all(
      sliderRefs.current.map(async (ref) => {
        if (ref) {
          try {
            return await toPng(ref, { pixelRatio: 3 });
          } catch (error) {
            console.error('Error generating slider image:', error);
            return null;
          }
        }
        return null;
      })
    );
  };

  const handleCopyReportApi = async (reportId, assessmentId, screening_date) => {
    const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
    try {
      await copyReport({ clientId, clientType, reportId, reportType, assessmentId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
      navigate(generatePath(CLIENT_REPORTS_LIST, { clientId, clientType }))
    } catch (error) {
      console.log('error copying report:', error)
    }
  }

  const handleCopyReport = async (e, reportId, assessmentId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, assessmentId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  return (
    <>
      {copyReportLoading && <LoadingOverlay />}
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        isLoading={copyReportLoading}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        type='school'
      />
      <section className="ReportSec proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, validateForm }) => (
                <Form onSubmit={handleSubmit}>
                  {isLoading ? (
                    <LoadingIndicator />
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      {console.log("FORMIK VALUES ", values)}
                      {console.log("ERROR oF VALIDATION ", errors)}
                      <ViewPdfModal
                        publishPdfCheckbox={true}
                        show={pdfModal}
                        clientType={clientType}
                        setShow={setPdfModal}
                        doc={document}
                        handleSubmit={submitForm}
                        guardianList={data?.client_detail?.client_guardian_mapping}
                      />
                      <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                      <AutosaveReport
                        onAutosave={handleSubmitStep}
                        isFetching={isFetching}
                      >
                        <Row>
                          <Col lg="12" className="my-2">
                            <div className="bg-white session-report" style={{ overflow: "hidden", paddingBottom: "50px" }}>
                              <>
                                {(isFetching || submitting) && <LoadingOverlay />}

                                <div className="formBody reports-v2 pt-3">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>{therapist?.therapist_discipline?.name}</h5>
                                      <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Clinical Report</p>
                                    </div>
                                    <div>
                                      {
                                        currentTab == 4 &&
                                        <button
                                          onClick={(e) => { handleCopyReport(e, reportId, assessmentId); setCurrentEntry({ id: reportId, assesment_type: assessmentId }) }}
                                          type="button"
                                          className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        // disabled={isFetching || submitting || copyReportLoading}
                                        // isLoading={submitReportLoading || submitting}
                                        >
                                          Make a Copy
                                        </button>
                                      }
                                    </div>
                                  </div>
                                  <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                                    <div className="d-flex gap_20">
                                      <div style={{ width: "145px" }}>
                                        <label style={{ fontSize: '14px' }} className="discharge-screen-label text-dark mb-1">DATE OF REPORT</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className="w-100 py-2"
                                          disabled={previewMode}
                                        />
                                      </div>
                                      {
                                        [2, 3].includes(currentTab) && (
                                          <div className="" style={{ width: "100%" }}>
                                            <h6 className="date-title w-100" style={{ paddingBottom: "6px", marginTop: "1px" }}>CLIENT INFORMATION</h6>
                                            <div className="d-flex text-dark align-items-center justify-content-between">
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>FIRST NAME</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.firstname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>LAST NAME</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.lastname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.city_town}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>DATE OF BIRTH</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{dateFormat(data?.client_detail?.dob, dobFormat)}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.grade}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{getAge(data?.client_detail?.dob)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <Row className="proxima-regular" style={{ fontSize: "11px", fontWeight: 500 }}>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 1 ? "#3DA0AA" : "#315D99", borderRadius: "3px", color: "white", textAlign: 'center' }}>CLIENT INFO</div>
                                      <div className={`${currentTab == 1 ? "arrow-right-tab-active" : "arrow-right-tab-previous"} position-relative`}></div>
                                      {/* <div className="arrow-right-tab-white position-relative"></div> */}
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 2 ? "#3DA0AA" : (currentTab == 3 || currentTab == 4) ? "#315D99" : "#D9E8FE", borderRadius: "3px", color: (currentTab == 3 || currentTab == 2 || currentTab == 4) ? "white" : "#315D99", textAlign: 'center' }}>BACKGROUND</div>
                                      <div className={`${currentTab == 2 ? "arrow-right-tab-active" : (currentTab == 3 || currentTab == 4) ? "arrow-right-tab-previous" : "arrow-right-tab"} position-relative`}></div>
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 3 ? "#3DA0AA" : currentTab == 4 ? "#315D99" : "#D9E8FE", borderRadius: "3px", color: (currentTab == 3 || currentTab == 4) ? "white" : "#315D99", textAlign: 'center' }}>OBSERVATIONS</div>
                                      <div className={`${currentTab == 3 ? "arrow-right-tab-active" : currentTab == 4 ? "arrow-right-tab-previous" : "arrow-right-tab"} position-relative`}></div>
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                    <Col lg="3" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 4 ? "#3DA0AA" : "#D9E8FE", borderRadius: "3px", textAlign: 'center', color: currentTab == 4 ? "white" : '#315D99' }}>RECOMMENDATIONS</div>
                                      {/* <div className={`${currentTab == 3 ? "arrow-right-tab-active" : "arrow-right-tab"} position-relative`}></div> */}
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                  </Row>
                                  {currentTab === 1 ? (
                                    <div
                                      className="mt-4 client-view"
                                    >
                                      <ClientDetails
                                        showDOB
                                        data={data}
                                        heading="1. CLIENT INFORMATION"
                                      />
                                      <h5 className="section-title mt-5">2. SCHOOL INFORMATION</h5>
                                      <div className="mb-3 d-flex align-items-center gap_20">
                                        <div style={{ width: "33%" }}>
                                          <label className="discharge-screen-label">School Name</label>
                                          {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.name}</div> */}
                                          <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.name} />
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <label className="discharge-screen-label">City / Town</label>
                                          <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.location} />
                                          {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.location}</div> */}
                                        </div>
                                      </div>
                                      {data?.client_detail?.client_guardian_mapping?.[0]?.client_guardian ?
                                        [...data.client_detail.client_guardian_mapping] // clone the array
                                          .map((guardian, index) => {
                                            const slug = guardian?.client_guardian?.client_role?.slug;
                                            if (slug !== (clientType === "school" ? "teacher" : "parent")) {
                                              return null;
                                            }
                                            if ([0, 1].includes(index)) {
                                              return (
                                                <GuardianDetailList
                                                  previewMode={previewMode}
                                                  key={index}
                                                  index={index}
                                                  guardian={guardian}
                                                  slug={slug}
                                                  values={values}
                                                />
                                              );
                                            }
                                            else {
                                              return
                                            }
                                          }) : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                      }
                                    </div>
                                  ) :
                                    currentTab === 2 ? (
                                      <div
                                        className="mt-1 session-info"
                                      >
                                        {reportQuestions?.length > 0 &&
                                          reportQuestions?.map((question, index) => {
                                            if (question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.customEditor) return (
                                              <div className="pt-4">
                                                <RenderQuestion
                                                  key={index}
                                                  question={question}
                                                  fieldName={question.id}
                                                  questionIndex={index + 1}
                                                />
                                              </div>
                                            );

                                          }
                                          )}
                                        {/* <div className="goals-tracking">
                                      <GoalsTracking
                                        onSubmit={() => console.log("Submit")}
                                        // onNavigateBack
                                        clientType={clientType}
                                        chartRefs={chartRefs}
                                        formRefs={formRefs}
                                        error={goalSubmissionError}
                                        data={data}
                                        refetch={refetch}
                                      />
                                    </div> */}
                                      </div>
                                    ) :
                                      currentTab === 3 ? (
                                        <div className="recommendations">
                                          <h6 className="section-title w-100" style={{ marginBottom: "1px", marginTop: "24px" }}>
                                            AREAS ADDRESSED
                                          </h6>
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.observation) return;
                                              return (
                                                <div className="pb-4">
                                                  {/* <RenderQuestion
                                                  key={index}
                                                  question={question}
                                                  fieldName={question.id}
                                                  questionIndex={1}
                                                  clientType={"school"}
                                                  assessmentId={assessmentId}
                                                /> */}
                                                  <QuestionMultipleObservation
                                                    speechToText
                                                    sliderRefs={sliderRefs}
                                                    chartRefs={chartRefs}
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={1}
                                                    clientType={"school"}
                                                    assessmentId={assessmentId}
                                                  />
                                                </div>
                                              );
                                            }
                                            )}
                                          {
                                            touched.observations && errors.observations ? (
                                              <div className="text-danger">{typeof (errors.observations) == "string" && errors.observations}</div>
                                            ) : null
                                          }
                                        </div>
                                      ) : (
                                        <div className="recommendations">
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id === CONSULTATION_REPORT_V2_QUESTIONS.clinical_impressions) return (
                                                <div className="py-4">
                                                  <RenderQuestion
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={1}
                                                  />
                                                </div>
                                              );
                                            }
                                            )}

                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.multiRecommendation) return;
                                              return (
                                                <div className="py-4">
                                                  {(
                                                    <h6 className="section-title w-100" style={{ marginBottom: "7px" }}>
                                                      {!isNaN(1) && `${2}. `}
                                                      {question?.question}
                                                    </h6>
                                                  )}
                                                  <QuestionMultipleRecommendation
                                                    speechToText
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    fieldData={reportRecommendations}
                                                    questionIndex={1}
                                                    clientType={"school"}
                                                    assessmentId={assessmentId}
                                                    maxRecommendations={4}
                                                  />
                                                  {/* <RenderQuestion
                                                  key={index}
                                                  question={question}
                                                  fieldName={question.id}
                                                  fieldData={reportRecommendations}
                                                  questionIndex={1}
                                                  clientType={"school"}
                                                  assessmentId={assessmentId}
                                                /> */}
                                                </div>
                                              );
                                            }
                                            )}
                                          <div className="mb-2">
                                            <h6 className="section-title text-uppercase">
                                              3. signature
                                            </h6>
                                            <div className="d-flex gap-2 mt-2 align-items-center">
                                              <input
                                                type="checkbox"
                                                className="form-check"
                                                style={{ accentColor: "#b46c9f", height: 20, width: 20 }}
                                                disabled={previewMode}
                                                onChange={(e) => {
                                                  if (values?.student?.value) {
                                                    setFieldValue('apprentice_id', e.target.checked ? caseApprentice?.id : null);
                                                  }
                                                  else {
                                                    errorMessageToast("Please select the apprentice")
                                                  }
                                                }}
                                                checked={values.apprentice_id === caseApprentice?.id}
                                              />
                                              <div className="d-flex student-cstm-select flex-1 w-100 gap-2 align-items-center">
                                                <span className="proxima" style={{ fontSize: "14px" }}>Add Student:</span>
                                                <Col md='4'>
                                                  <AppSelect2Field
                                                    name='student'
                                                    option={caseApprentice?.therapist_id ? [{ label: userFullName(caseApprentice?.caseTherapist), value: caseApprentice?.therapist_id }] : []}
                                                    placeholder="Select a student..."
                                                    classNamePrefix="khan"
                                                  />
                                                </Col>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                  }
                                </div>
                              </>
                            </div>
                          </Col>
                          {/* <button type="button" onClick={() => getExample()}>
                          VIEW IMAGE
                        </button> */}
                          <Col lg="12" className="my-2">
                            <ReportError />
                            <div className='d-flex gap-3 align-items-center justify-content-between'>
                              <div>
                                {currentTab > 1 && (
                                  <button
                                    onClick={() => setCurrentTab(currentTab - 1)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    <ArrowLeftIcon />
                                    {"Back"}
                                  </button>
                                )}
                              </div>
                              <div className="d-flex gap-3 align-items-center justify-content-between">
                                <ReportSubmitButton
                                  onClick={() => setFieldValue('saveForLater', true)}
                                  type="submit"
                                  className="d-flex gap-2 align-items-center justify-content-center save-discharge-screen"
                                  disabled={previewMode || isFetching || submitting}
                                // isLoading={submitReportLoading || submitting}
                                >
                                  Save
                                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                                  </svg>
                                </ReportSubmitButton>
                                {currentTab === 4 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                      // isLoading={submittingStep}
                                      disabled={isFetching || submitting}
                                      onClick={() => handleViewPdf(values)}
                                    >
                                      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                      </svg>
                                      Preview Report
                                    </button>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        // onClick={() => setFieldValue('saveForLater', false)}
                                        onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        SUBMIT
                                        {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                      </ReportSubmitButton>
                                    }
                                  </>
                                ) : (
                                  <button
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (isEmpty(errors)) {
                                        setFieldValue('saveForLater', true);
                                        await submitForm();
                                        setCurrentTab(currentTab + 1);
                                      }
                                    }}
                                    type="submit"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Next
                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                    </svg>
                                  </button>
                                )}
                              </div>
                            </div>
                          </Col>

                        </Row>
                      </AutosaveReport>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Container>
      </section >
    </>
  );
};

export default SchoolConsultationReport;